import useWidth from '../../../../../components/Hooks/useWidth';
import useIsAdminSeller from '../../../../../stores/ShowUnavailableProducts/hooks/useIsAdminSeller';
import { GridStoreProvider } from '../../../../orders/products/product/grid/store/GridStoreProvider';
import CatalogProductsListV2 from '../../v2/CatalogProductsListV2';
import { useCatalogView } from '../../v2/contexts/CatalogView.context';
import useCatalogCardColumns from '../../v2/hooks/useCatalogCardColumns';
import { CatalogListCopiedGridProvider } from '../../v2/list/contexts/CatalogListCopiedGrid.context';
import { useCatalogListGridAfterSave } from '../../v2/list/hooks/useCatalogListGridAfterSave';
import { resolveCanManageSections } from '../../v2/utils/resolveCanManageSections';
import { CatalogViewMode } from '../../v2/view/catalogView.types';

interface CatalogListPlaceholderProps {
  catalogId: string;
  isCatalogSettled: boolean;
  isPreferencesSettled: boolean;
  readMode: boolean;
  isOfflineMode?: boolean;
  canPersist?: boolean;
}

const CatalogListPlaceholder = ({
  catalogId,
  isCatalogSettled,
  isPreferencesSettled,
  readMode,
  isOfflineMode = false,
  canPersist = false,
}: CatalogListPlaceholderProps) => {
  const { mobileWidth } = useWidth();
  const { effectiveMode, applied } = useCatalogView();
  const maxItemsPerRow = useCatalogCardColumns();
  const pageSize = mobileWidth ? 10 : 20;
  const { handleAfterSave } = useCatalogListGridAfterSave();
  const isAdminSeller = useIsAdminSeller();

  const canManageSections = resolveCanManageSections({
    appliedGroupBy: applied.groupBy,
    isCatalogSettled,
    isPreferencesSettled,
    canPersist,
    readMode,
    isAdminSeller,
  });

  const list = (
    <CatalogProductsListV2
      key={effectiveMode}
      catalogId={catalogId}
      maxItemsPerRow={maxItemsPerRow}
      pageSize={pageSize}
      isOfflineMode={isOfflineMode}
      canPersist={canPersist}
      canManageSections={canManageSections}
    />
  );

  if (effectiveMode !== CatalogViewMode.LIST) {
    return list;
  }

  return (
    <GridStoreProvider onAfterSave={handleAfterSave}>
      <CatalogListCopiedGridProvider>{list}</CatalogListCopiedGridProvider>
    </GridStoreProvider>
  );
};

export default CatalogListPlaceholder;
